// extracted by css-extract-rspack-plugin
export default {"cls1":"Modal-cls1_fnW","cls2":"Modal-cls2_c3A Modal-cls1_fnW"};